import React from 'react';

import once from 'lodash/once';

import GoogleAnalytics from '@common/react/components/google/GoogleAnalytics/GoogleAnalytics';

interface GoogleKeysProviderProps {
	analyticsId?: string;
	mapKey?: string;
	geocodeKey?: string;
	tagManagerId?: string;
	skipAnalytics?: boolean;
}

interface GoogleKeysProviderState {
	analyticsId?: string;
	mapKey?: string;
	geocodeKey?: string;
	tagManagerId?: string;
}

interface GoogleKeysProviderActions {
	setKey: (key: string, value: string) => void;
}

interface GoogleKeysProviderContext {
	state: GoogleKeysProviderState;
	actions: GoogleKeysProviderActions
}

export const createGoogleKeysProviderContext = once(() => React.createContext({} as GoogleKeysProviderContext));

export const useGoogleKeysProviderContext: () => GoogleKeysProviderContext = () => React.useContext(createGoogleKeysProviderContext());

const GoogleKeysProvider: React.FC<GoogleKeysProviderProps> = (props) => {
	const {
		children,
		geocodeKey,
		skipAnalytics,
		...rest
	} = props;
	const [keys, setKeys] = React.useState<GoogleKeysProviderState>({
		...rest,
		geocodeKey: geocodeKey ?? rest.mapKey,
	});
	const setKey = (key: string, value: string) => {
		setKeys((prev) => ({
			...prev,
			[key]: value,
		}));
	};

	const ItemContext = createGoogleKeysProviderContext();

	const value = {
		state: keys,
		actions: { setKey },
	};
	return <ItemContext.Provider value={value}>
		{!skipAnalytics && rest.analyticsId && <GoogleAnalytics />}
		{children}
	</ItemContext.Provider>;
};

export default GoogleKeysProvider;
